import Component from '../core/Component'
import { CMS } from '../core/config'
import { queryAll } from '../utils/dom'
import PositionObserver from '../meta/PositionObserver'

const STATES = {
    READY: 'is-ready',
}

export default class TextReveal extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            items: [],
        }

        this.isActive = false
        this.hasEntered = false
    }

    prepare() {
        if (CMS) {
            return
        }

        if (this.ref.items.length === 0) {
            this.ref.items.push(this.element)
        }

        this.ref.items.forEach((item) => {
            item.innerHTML = item.innerHTML
                .trim()
                .split(' ')
                .map((item) => `<span class="t-Up">${item}</span>`)
                .join(' ')
        })

        this.element.classList.add(STATES.READY)

        this.items = queryAll('.t-Up', this.element)

        this.observer = new PositionObserver(this.element, {
            onEnter: this.handleEnter,
            onRender: this.handleRender,
            onBeforeResize: this.handleResize,
        })

        this.refresh()
    }

    handleResize = () => {
        this.refresh()
    }

    handleEnter = () => {
        this.isActive = true
    }

    handleRender = ({ bodyRatio }) => {
        if (!this.isActive || this.hasEntered) {
            return
        }

        if (bodyRatio > 0.3) {
            this.hasEntered = true
            this.element.classList.add('has-entered')
            this.observer?.destroy()
        }
    }

    refresh() {
        const items = this.items
            .map((element) => ({
                element,
                top: element.getBoundingClientRect().top,
            }))
            .map((item, index, list) => {
                if (index === 0) {
                    item.row = 1
                } else {
                    item.row =
                        item.top === list[index - 1].top
                            ? list[index - 1].row
                            : list[index - 1].row + 1
                }
                return item
            })

        const rows = Math.max(...items.map((item) => item.row))

        items.forEach(
            (item) =>
                (item.element.className = `t-Up t-Up--f${item.row} t-Up--b${rows - item.row + 1}`),
        )
    }
}
